import AddLoads from "./AddLoads";

export default AddLoads;
